import type { JSX } from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { CandidateFormFields } from './CandidateFormFields';
import { useCandidateFormState } from './CandidateFormDialog.hooks';
import type { CandidateFormDialogProps } from './CandidateFormDialog.utils';

function FormButtons({
  isLoading,
  submitLabel,
  onClose,
}: {
  isLoading: boolean;
  submitLabel: string;
  onClose: () => void;
}): React.JSX.Element {
  return (
    <DialogFooter>
      <Button type="button" variant="outline" onClick={onClose}>
        Cancel
      </Button>
      <Button type="submit" disabled={isLoading}>
        {submitLabel}
      </Button>
    </DialogFooter>
  );
}

export function CandidateFormDialog({
  open,
  onOpenChange,
  mode,
  candidate,
}: CandidateFormDialogProps): JSX.Element {
  const form = useCandidateFormState({ mode, candidate, onOpenChange });

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-row-click-ignore className="sm:max-w-[425px]">
        <DialogHeader>
          <DialogTitle>{form.title}</DialogTitle>
        </DialogHeader>
        <form onSubmit={form.onSubmit} className="space-y-4">
          <CandidateFormFields
            register={form.register}
            errors={form.errors}
            onCountryChange={form.setCountry}
            defaultCountry={form.country}
          />
          <FormButtons
            isLoading={form.isLoading}
            submitLabel={form.submitLabel}
            onClose={form.handleClose}
          />
        </form>
      </DialogContent>
    </Dialog>
  );
}
